export default __webpack_public_path__ + "static/media/logo.393d7ad3.svg";